import { render, staticRenderFns } from "./JitsiMeeting.vue?vue&type=template&id=156960d8"
import script from "./JitsiMeeting.vue?vue&type=script&lang=js"
export * from "./JitsiMeeting.vue?vue&type=script&lang=js"
import style0 from "./JitsiMeeting.vue?vue&type=style&index=0&id=156960d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports